import { render, staticRenderFns } from "./NoticePage.vue?vue&type=template&id=5c899d82&scoped=true&lang=true&"
import script from "./NoticePage.vue?vue&type=script&lang=js&"
export * from "./NoticePage.vue?vue&type=script&lang=js&"
import style0 from "./NoticePage.vue?vue&type=style&index=0&id=5c899d82&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c899d82",
  null
  
)

export default component.exports